import { Fragment } from 'react';
import { Minifiable } from '@optimus-web/common';
import Step, { StepDescription } from './Step';
import { StepBarContainer, StepLineElement } from './style';

export interface StepBarProps extends Minifiable {
    steps: StepDescription[];
    activeStep?: string;
    onStepChange?: (value: string) => void;
    numbered?: boolean;
    vertical?: boolean;
}

const StepBar = ({ steps, activeStep, onStepChange, numbered, vertical, small, ...other }: StepBarProps) => {
    const activeItemIndex = steps.findIndex((item) => item.value === activeStep);
    const singleItem = steps.length === 1;

    return (
        <StepBarContainer vertical={vertical} {...other}>
            {steps.map(({ value, active, completed, order, ...props }, index) => {
                const isActive = activeStep === value;
                const isCompleted = completed || activeItemIndex > index;

                return (
                    <Fragment key={value}>
                        {index > 0 ? (
                            <StepLineElement aria-hidden primary={completed || isActive} vertical={vertical} />
                        ) : null}
                        <Step
                            index={order || index}
                            value={value}
                            onClick={onStepChange}
                            completed={isCompleted}
                            active={isActive}
                            numbered={numbered}
                            vertical={vertical}
                            small={small}
                            singleItem={singleItem}
                            {...props}
                        />
                    </Fragment>
                );
            })}
        </StepBarContainer>
    );
};

export default StepBar;
